@if (control$$() && readonly$$()) {
    <!-- Readonly: alleen de gekozen optie(s), als readonly tekstveld. InputControlComponent neemt [value]
         alleen bij init over — de @for met track op de tekst bouwt het veld opnieuw op bij een andere keuze. -->
    @for (text of [selectedText$$()]; track text) {
        <app-input-control
            [value]="text"
            [hint]="input_hint$$()"
            [hintAlign]="input_hintAlign$$()"
            [label]="input_label$$()"
            [readonly]="true"
        />
    }
} @else if (control$$()) {
    <!-- Edit: label boven de groep, hint/fout eronder (../../choice-field.scss, zonder veldvlak). Zonder kader
         ([framed]="false", bv. in een werkbalk) alleen de groep: geen zichtbaar label, subscript alleen bij hint of fout. -->
    <div [class.choice-field]="input_framed$$()" [class.choice-field--error]="input_framed$$() && control$$().invalid && errorShow$$()">
        @if (input_label$$() && input_framed$$()) {
            <label class="choice-field__label">{{input_label$$()}}:</label>
        }
        <mat-button-toggle-group
            (change)="emit_valueChange($event.value)"
            [appearance]="input_appearance$$()"
            [attr.aria-label]="input_label$$() || null"
            [formControl]="control$$()"
            [hideMultipleSelectionIndicator]="input_hideMultipleSelectionIndicator$$()"
            [hideSingleSelectionIndicator]="input_hideSingleSelectionIndicator$$()"
            [multiple]="input_multiple$$()"
            [vertical]="input_vertical$$()"
        >
            @for (item of input_list$$(); track itemValue(item)) {
                <mat-button-toggle
                    [disableRipple]="input_disableRipple$$()"
                    [tabIndex]="tabIndexNumber$$()"
                    [value]="itemValue(item)"
                >
                    @if (itemIcon(item); as icon) {
                        <app-icon class="toggle-icon" [name]="icon" size="1em" />
                    }
                    {{itemText(item)}}
                </mat-button-toggle>
            }
        </mat-button-toggle-group>
    </div>
    @if (input_framed$$() || (control$$().invalid && errorShow$$()) || input_hint$$()) {
        <div class="choice-field__subscript">
            @if (control$$().invalid && errorShow$$()) {
                <mat-error>{{errorMessage_getFirst()}}</mat-error>
            } @else if (input_hint$$()) {
                <span class="choice-field__hint" [class.choice-field__hint--end]="input_hintAlign$$() === _hintAlign.end">{{input_hint$$()}}</span>
            }
        </div>
    }
}
